module.exports = __webpack_public_path__ + "static/img/招商证券.fa48fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/招商证券.png
// module id = B6Qy
// module chunks = 3